export const IMPORT_PATH = '/cp/import'
export const MAILCHIMP_FLOW_PATH = '/cp/import/mailchimp'
export const IMPORT_PROGRESS_PATH = '/cp/import/mailchimp/progress'
